import React from "react";
import EditEmploymentLine from "./EditEmploymentLine";
import NewEmploymentLine from "./NewEmploymentLine";
import InlinePendingRow from "../../../profiles/InlinePendingRow";

function EmploymentEditorActive({
  employmentState: { employments, addEmployment, removeEmployment, setFeatured, updateEmployment, isUpdating },
}) {
  return (
    // Fixed layout + a colgroup bound the picker column to a fixed share of the table width. Without it
    // the company picker (react-select) auto-sizes its input to the typed text, so a long value grows the
    // cell and pushes the action buttons off-screen; fixed layout locks each column to its colgroup width
    // and clips the overflow inside the control instead. Every column carries an explicit percentage that
    // sums to 100%: a lone auto column does NOT absorb the leftover between the table's 100% width and the
    // sized columns under fixed layout — it collapses to ~0 and strands the surplus as dead space, which
    // squeezes the title down to one word per line and overlaps the headers. table-responsive lets a
    // narrow viewport scroll rather than crushing the date/action columns below the table's min-width.
    <div className="table-responsive">
      <table className="table" style={{ tableLayout: "fixed", minWidth: "40rem" }}>
        <colgroup>
          <col style={{ width: "21%" }} />
          <col style={{ width: "24%" }} />
          <col style={{ width: "16%" }} />
          <col style={{ width: "16%" }} />
          <col style={{ width: "23%" }} />
        </colgroup>
        <thead>
          <tr>
            <th>Company</th>
            <th>Title</th>
            <th>From</th>
            <th>To</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {employments.map((line) => (
            <EditEmploymentLine
              key={line.id}
              employment={line}
              onChange={(updatedFields) => updateEmployment(line.id, updatedFields)}
              onRemove={() => removeEmployment(line.id)}
              onSetFeatured={(featured) => setFeatured(line.id, featured)}
              disabled={isUpdating}
            />
          ))}
          <NewEmploymentLine onNewEmployment={addEmployment} disabled={isUpdating} />
          <InlinePendingRow isPending={isUpdating} />
        </tbody>
      </table>
    </div>
  );
}

export default EmploymentEditorActive;
